import { render, staticRenderFns } from "./dashboard-auto-refresh.vue?vue&type=template&id=2d92b0f3"
import script from "./dashboard-auto-refresh.vue?vue&type=script&lang=js"
export * from "./dashboard-auto-refresh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports